import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // no-op for now. Could add polling if streaming later.
  }
}


